import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import BIPOC from '../../assets/images/support-services/bipoc.jpg';
import Andropause from '../../assets/images/support-services/andropause.jpg';
import FertilityWin from '../../assets/images/support-services/fertility.jpg';
import FertilityHighmark from '../../assets/images/support-services/fertility12.jpg';
import BehavioralHealth from '../../assets/images/support-services/behavioral-health.jpg';
import CaregiverSupport from '../../assets/images/support-services/caregiver-support.jpg';
import ChildDevelopment from '../../assets/images/support-services/child-development.jpg';
import Maternity from '../../assets/images/support-services/maternity.jpg';
import Menopause from '../../assets/images/support-services/menopause.jpg';
import Nutrition from '../../assets/images/support-services/nutrition.jpg';
import Preconception from '../../assets/images/support-services/preconception.jpg';
import Surrogacy from '../../assets/images/support-services/surrogacy.jpg';
import Adoption from '../../assets/images/support-services/adoption.jpg';
import WomensHealth from '../../assets/images/support-services/womens-health.jpg';
import WINforHim from '../../assets/images/support-services/win-for-him.jpg';
import LGBTQIA from '../../assets/images/support-services/lgbtqia.jpg';
import GenderAfirm from '../../assets/images/support-services/Gender_Affirming_support.jpg';
import ExpertCoaching from '../../assets/images/support-services/NewExpertCoaching.png';
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import Doulas from '../../assets/images/support-services/Doulas.jpg';
import { useTranslation } from 'react-i18next';
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

const SupportServices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // const ServiceDescription = location.state?.text || "Support Services"; // Retrieve ServiceDescription from state
  const ServiceDescription = location.state?.originalText || location.state?.text || "Support Services";
const displayServiceDescription = location.state?.displayText || ServiceDescription;
const isBranchIORedirection = location.state?.isBranchIORedirection || false;

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const {isChatVisible, toggleChat, showChat } = useChat();

  // Retrieve required parameters from Redux
  const userInfo = useSelector((state) => state.userData.userData);
  const contract = useSelector((state) => state.userData.userData.ContractIdentified);
  const token = localStorage.getItem('AccessToken');
  const deviceType = "PatientPortal";
  // States for storing service details and errors
  const [serviceDetails, setServiceDetails] = useState([]);
  const [error, setError] = useState(null);

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [loading, setLoading] = useState(true);

  // Fetch service details on component mount
  useEffect(() => {
    const fetchServiceDetails = async () => {
      try {
        const params = {
          EmailId: userInfo.EmailID,
          ServiceDescription: ServiceDescription,
          Contract: contract,
          DeviceType:deviceType
        };

        // Making the API call
        const response = await axios.post(
          Endpoints.GetDashboardServiceDetails,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            }
          }
        );

        // Update service details if response is successful
        if (response.data?.ServiceDetails) {
          setServiceDetails(response.data.ServiceDetails);
        }
      } catch (error) {
        setError(error);
      }   finally {
      setLoading(false); // <-- Ensure loading is set to false after fetch
    }
    };

    // Fetch the details only if emailId and ServiceDescription are available
    if (userInfo.EmailID && ServiceDescription) {
      fetchServiceDetails();
    }
  }, [userInfo.EmailID, ServiceDescription, contract, token]);

  const getServiceImage = (serviceType) => {
    switch (serviceType) {
      case 'LGBTQIA+':
        return LGBTQIA;
      case 'BIPOC':
        return BIPOC;
      case 'Maternity':
        return Maternity;
      case 'Fertility':
        return  isHighmarkPortal?FertilityHighmark:FertilityWin;
      case 'Preconception':
        return Preconception;
      case 'Behavioral Health':
        return BehavioralHealth;
      case 'Nutrition':
        return Nutrition;
      case 'Child Development':
        return ChildDevelopment;
      case 'Caregiver Support':
        return CaregiverSupport;
      case 'Menopause':
        return Menopause;
      case 'Andropause':
        return Andropause;
      case 'WIN for Him':
        return WINforHim;
      case 'Surrogacy':
        return Surrogacy;
        case 'Adoption':
          return Adoption;
      case "Women's Health":
        return WomensHealth;
        case "Doulas":
          return Doulas;
          case 'Gender-Affirming Support':
                    return GenderAfirm;
        case 'Expert Coaching':
        return ExpertCoaching;            
      default:
        console.log("No image found"); // Log when image not found
        return null; // Return null if no match is found
    }
  };
  const handleOkClick = () => {
    setShowModal(false);
  };

  const OidcIntegration =async(vendor)=>{
    const params = {
      emailId: userInfo.EmailID,
      vendor : vendor,
    };
try {
    // Making the API call
    const response = await axios.post(
      Endpoints.OidcIntegration,
      `_Params=${encodeURIComponent(JSON.stringify(params))}`,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        }
      }
    );
    if (response?.data) {
      window.open(response?.data, "_blank");
    }
  } catch (error) {
    setError(error);
  }   finally {
  // setLoading(false); // <-- Ensure loading is set to false after fetch
}
  };
  const loadCallRecoderLog=(service)=>
  {
    const deviceType = "PatientPortal";
    const servicemodule="Support";
     const formattedActivity = `${servicemodule}:${ServiceDescription}:${service.ServiceDetailDescription}`;
     const formattedActivityExternallink = `${servicemodule}:${ServiceDescription}:${service.ServiceDetailDescription}:${service.WebLink}`;
     // Check if ServiceDescription matches specific cases
  const specificCases = [
    "Ovulation tracking bracelet",
    "At-home sperm testing kit",
    "WIN Virtual Network",
     "WIN Maternity powered by Ovia",
      "WIN Maternity powered by Cleo",
      "WIN Baby powered by Cleo",
      "WIN Milk",
      "Preeclampsia Genetic Testing"
  ];
  const activityToLog = specificCases.includes(service.ServiceDetailDescription)
    ? formattedActivityExternallink
    : formattedActivity;
   
     //  console.log(formattedActivity)
     if (userInfo.EmailID && token) {
       try {
         const payload = `_Params=${encodeURIComponent(
           JSON.stringify({ EmailID: userInfo.EmailID, Activity: activityToLog, DeviceType: deviceType })
         )}`;
         axios.post(Endpoints.CallRecoderLog, payload, {
           headers: {
             "Content-Type": "application/x-www-form-urlencoded",
             Authorization: `Bearer ${token}`,
           },
         });
 
       } catch (error) {
       }
     }
  }
  // Function to handle navigation based on service description
  const handleCardClick = (service) => {
    debugger
    switch (service.ServiceDetailDescription) {
      case "Connect with an Advocate":
        navigate("/book-appointment", { state: { servicedescription: ServiceDescription } });
        break;
        case "Pediatric Behavioral Health":
          OidcIntegration("Bend");
          break;
          case "Pediatric Virtual Network":
            navigate("/pediatric-care");
            break;
      case "Explore Resources":
        loadCallRecoderLog(service);
        if (ServiceDescription === "Child Development") {
          navigate("/child-development", { state: { link: service.WebLink } });
        } else {
          navigate("/feedServices", { state: { link: service.WebLink, description: isHighmarkPortal?displayServiceDescription:ServiceDescription, videolink:service.VideoLink, documentlink:service.DocumentLink} });
        }
        break;
      case "Ovulation tracking bracelet":
        break;
      case "At-home sperm testing kit":
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
        break;
      case "WIN Virtual Network" && "Connect with a Caregiving Expert":
        if(displayServiceDescription === 'Caregiver Support'){
          OidcIntegration("FamilyFirst");
        }
        else 
        {
           if (service.WebLink) {
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
      }
        }
        break;
      case "Milk Shipping":
        break;
      case "WIN Maternity powered by Ovia":
        break;
      case "WIN Maternity powered by Cleo":
        break;
         case "Breast Milk Shipping & Lactation Tools":
          OidcIntegration("Milkstork");
          break;
      case "WIN Baby powered by Cleo":
        if (service.WebLink) {
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
      }
      break;
      case "At Home Menopause Test":
        if (service.WebLink) {
          loadCallRecoderLog(service);
          window.open(service.WebLink, "_blank");
        }
        break;
      case "WIN Milk":
        break;
        case "Preeclampsia Genetic Testing":
        if (!service.WebLink) {
          setModalMessage(
           t("virtualnetworkmessage")
          );
          setShowModal(true);
        } else {
          loadCallRecoderLog(service);
          window.open(service.WebLink, "_blank");
        }
        break;
        case "Pregnancy Symptom Tracker":
          navigate("/pregnancy");
          break;
        case "Fertility Tracker":
          navigate("/fertility");
          break;
          case "Andropause Symptom Tracker":
            navigate("/andropause");
            break;
            case "Menopause Symptom Tracker":
            navigate("/menopause");
            break;
            case "Expert Coaching":
              if (service.WebLink) {
                loadCallRecoderLog(service);
                window.open(service.WebLink, "_blank");
              }
              break;
        case "Weekly Pregnancy Tracker":
             navigate("/weekly-pregnancy-tracker");
          break;
          case "Wincentive Rewards":
             navigate("/incentive-landingpage");
             break;
         case "Find Care":
              navigate("/load-findcare-list");
              break;
      case "Additional Coaching Support":
      if (service.WebLink) {
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
      }
      break;
      case "At Home Ovulation Tracking":
        if (service.WebLink) {
          loadCallRecoderLog(service);  
          window.open(service.WebLink, "_blank");
        }
      break;
      case "Return to Work Support":
        navigate("/return-to-work-support");
        break;
        case "Get Expert Adoption Coaching":
          if (service.WebLink) {
          loadCallRecoderLog(service);  
          window.open(service.WebLink, "_blank");
        }
        case "Get Expert Surrogacy Coaching":
           if (service.WebLink) {
          loadCallRecoderLog(service);  
          window.open(service.WebLink, "_blank");
        }
      default:
        if (service.WebLink) {
    loadCallRecoderLog(service);
    window.open(service.WebLink, "_blank");
  }
        break;
    }
  };
  const handleBackClick = () => {
    console.log("isBranchIORedirection ; ", isBranchIORedirection)
  if (isBranchIORedirection) {
    navigate("/home");
  } else {
    navigate(-1); 
  }// Redirects to the home page
  };
  // const getDescription = (title) => {
  //   switch (title) {
  //     case "Connect with an Advocate":
  //       return t("connectwithanadvocate");
  //     case "Explore Resources":
  //       return t("exploreresources");
  //     case "Child Development":
  //       return t("childdevelopment");
  //     case "Ovulation tracking bracelet":
  //       return t("ovulationtrackingbracelet");
  //     case "At-home sperm testing kit":
  //       return t("athomespermtestingkit");
  //     case "WIN Virtual Network":
  //       return t("winvirtualnetwork");
  //     case "WIN Maternity powered by Ovia":
  //       return  t("winmaternitypoweredbyoviades")
  //     case "WIN Maternity powered by Cleo":
  //         return t("winmaternitypoweredbycleodes")
  //     case "Pregnancy Symptom Tracker":
  //          return t("Pregnancydecsription")    
  //     case "Weekly Pregnancy Tracker":
  //       return t("weeklypregnancyTracker")
  //       case "Fertility Tracker":
  //         return t("fertilitydescription")
  //          case "Wincentive Rewards":
  //         return t("wincentiverewards")
  //         case "WIN Baby powered by Cleo":
  //           return "no description";
  //           case "WIN Milk":
  //             return "A program delivering essential resources to support moms and their babies.";
  //         case "Menopause Symptom Tracker":
  //           return t("Menopausedescription")
  //           case "Andropause Symptom Tracker":
  //             return t("andropausedescription")
  //             case "Find Care":  
  //     // Handling "Find Care" descriptions based on ServiceDescription
  //     if (ServiceDescription === "Women's Health") {
  //       return "Connect with in-network providers who offer compassionate and comprehensive women's health care.";
  //     }
  //     if (ServiceDescription === "BIPOC") {
  //       return "Access care with providers who identify as BIPOC and prioritize cultural sensitivity.";
  //     }
  //     if (ServiceDescription === "LGBTQIA+") {
  //       return "Access care with providers who specialize in LGBTQIA+ care and support your unique needs throughout your journey.";
  //     }
  //     if (ServiceDescription === "Fertility") {
  //       return "Find in-network reproductive endocrinologists to support your family-building goals.";
  //     }
  //     if(ServiceDescription==="Doulas")
  //     {
  //       return "Find in-person and virtual providers to support you on your pregnancy journey."
  //     }
  //       default:
  //         return t("nodescription");
  //   }
  // };

  const getDescription = (title) => {
    switch (title) {
      case "Connect with an Advocate":
        if (ServiceDescription === "Adoption") {
        return { iconClass: "connect-with-advocate", description: "Get help with benefit details, claims, coverage questions, and how to maximize your benefit on your adoption journey" };
        } else if (ServiceDescription === "Surrogacy") {
        return { iconClass: "connect-with-advocate", description: "Get help with benefit details, claims, coverage questions, and how to maximize your benefit on your surrogacy journey" };
      } else {
        return { iconClass: "connect-with-advocate", description: t("connectwithanadvocate") };
        }
        case "Pediatric Behavioral Health":
        return { iconClass: "win-behavioral-health", description: t("winpediatricbehavioralhealth") };
        case "Pediatric Virtual Network":
        return { iconClass: "win-pediatric-network", description: t("winpediatricvirtualnetwork") };
      case "Explore Resources":
        return { iconClass: "explore-resources",  description: isHighmarkPortal ? t("himarkexploreresources") : t("exploreresources")};
      case "Child Development":
        return { iconClass: "bi-heart", description: t("childdevelopment") };
      case "Ovulation tracking bracelet":
        return { iconClass: "ovulation-tracking-bracelet", description: t("ovulationtrackingbracelet") };
      case "At-home sperm testing kit":
        return { iconClass: "sperm-testing-kit",  description: t("athomespermtestingkit") };
        case "At Home Menopause Test":
          return { iconClass: "at-home-menopause-test",  description: "Get personalized insights with easy-to-use hermone monitor" };
      case "WIN Virtual Network":
        return { iconClass: "win-virtual-network",  description: t("winvirtualnetwork") };
      case "Milk Shipping":
        return { iconClass: "milk-shipping", description: t("Convenient milk shipping service to ensure timely delivery of breast milk supplies.") };
     case "Breast Milk Shipping & Lactation Tools":
      return { iconClass: "breast-milk-shipping", description: t("breastmilkshipping") };
        case "WIN Maternity powered by Ovia":
        return { iconClass: "maternity-powered-by-ovia", description: t("winmaternitypoweredbyoviades") };
      case "WIN Maternity powered by Cleo":
        return { iconClass: "maternity-powered-by-cleo", description: t("winmaternitypoweredbycleodes") };
      case "WIN Baby powered by Cleo":
        return { iconClass: "maternity-powered-by-cleo", description: "Pair with your Cleo Guide who is there to support you on your parenting journey" };
        case "Pregnancy Symptom Tracker":
        return { iconClass: "pregnancy-symptom-tracker", description: t("Pregnancydecsription") };
      case "Weekly Pregnancy Tracker":
        return { iconClass: "wheekly-pregnancy-tracker", description: t("weeklypregnancyTracker") };
      case "Fertility Tracker":
        return { iconClass: "fertility-tracker",description: t("fertilitydescription") };
      case "Wincentive Rewards":
        return { iconClass: "wincentive-rewards", description: t("wincentiverewards") };
      case "Menopause Symptom Tracker":
        return { iconClass: "menopause-symptom-tracker", description: t("Menopausedescription") };
      case "Andropause Symptom Tracker":
        return { iconClass: "andropause-symptom-tracker",description: t("andropausedescription") };
        case "At Home Ovulation Tracking":
          return { iconClass: "at-home-ovulation-tracking", description: "Get personalized fertility insights with easy-to-use hormone monitor" };
        case "WIN Milk":
          return { iconClass: "win-milk-icon",description: "A program delivering essential resources to support moms and their babies" };
          case "Return to Work Support":
          return { iconClass: "return-to-work-support",description: "Complete this short form to help us understand your needs-then book a 1:1 consult with our Return to work Advocate" };
          case "Expert Coaching":
          return { iconClass: "expert-coaching",description: "1:1 support with everyday challenges_sleep, eating, potty training and everything in between" };
          case "Preeclampsia Genetic Testing" :
          return { iconClass: "preeclampsia-genetic-testing", description: "At-home blood test between 18-22 weeks of pregnancy to predict and address preeclampsia in advance of symptoms" };
      case "Find Care":
        if (ServiceDescription === "Women's Health") {
          return { iconClass: "find-care", description: "Connect with in-network providers who offer compassionate and comprehensive women's health care" };
        }
        if (ServiceDescription === "BIPOC") {
          return { iconClass: "find-care", description: "Access care with providers who identify as BIPOC and prioritize cultural sensitivity" };
        }
        if (ServiceDescription === "LGBTQIA+") {
          return { iconClass: "find-care",  description: "Access care with providers who specialize in LGBTQIA+ care and support your unique needs throughout your journey" };
        }
        if (ServiceDescription === "Fertility") {
          return { iconClass: "find-care", description: "Find in-network reproductive endocrinologists to support your family-building goals" };
        }
        if (ServiceDescription === "Doulas") {
          return { iconClass: "find-care", description: "Find in-person and virtual providers to support you on your pregnancy journey" };
        }
        return { iconClass: "find-care",description: "Find the right healthcare providers who align with your personal needs, preferences, and health journey" };
      
        case "Additional Coaching Support":
      if (ServiceDescription === "Surrogacy") {
        return {
          iconClass: "connect-with-advocate",
          description: "Get additional coaching from experts to help in your Surrogacy journey"
        };
      } else if (ServiceDescription === "Adoption") {
        return {
          iconClass: "connect-with-advocate",
          description: "Get additional coaching from experts to help in your Adoption journey"
        };
      } else {
        return {
          iconClass: "connect-with-advocate",
          description: "Get additional coaching from experts to support your family-building journey"
        };
      }
      case "Get Expert Adoption Coaching":
        return {
          iconClass: "connect-with-advocate",
          description: "Your primary resource for expert guidance in adoption options—powered by a trustworthy network of industry experts"
        };
        case "Get Expert Surrogacy Coaching":
          return {
          iconClass: "connect-with-advocate",
          description: "Your primary resource for expert guidance in surrogacy and donor options—powered by a trustworthy network of industry experts"
        };
        case "Connect with a Caregiving Expert":
          return {
          iconClass: "connect-with-advocate",
          description: "Take the first step of your caregiving journey by connecting with a Family First Advocate"
        };
      default:
        return { iconClass: "win-virtual-network", description: t("nodescription") };

      // case "Find Care":
      //   if (ServiceDescription === "Women's Health") {
      //     return { iconClass: "bi-person-heart", description: "Connect with in-network providers who offer compassionate and comprehensive women's health care." };
      //   }
      //   if (ServiceDescription === "BIPOC") {
      //     return { iconClass: "bi-people", description: "Access care with providers who identify as BIPOC and prioritize cultural sensitivity." };
      //   }
      //   if (ServiceDescription === "LGBTQIA+") {
      //     return { iconClass: "bi-rainbow",  description: "Access care with providers who specialize in LGBTQIA+ care and support your unique needs throughout your journey." };
      //   }
      //   if (ServiceDescription === "Fertility") {
      //     return { iconClass: "bi-baby-carriage", description: "Find in-network reproductive endocrinologists to support your family-building goals." };
      //   }
      //   if (ServiceDescription === "Doulas") {
      //     return { iconClass: "bi-person-hearts", description: "Find in-person and virtual providers to support you on your pregnancy journey." };
      //   }
      //   return { iconClass: "bi-hospital",description: "Find the right healthcare providers who align with your personal needs, preferences, and health journey." };
      // default:
      //   return { iconClass: "bi-info-circle", description: t("nodescription") };
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
  
  return (
    <>

      {isHighmarkPortal ? 
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>       
          <h2 className="page-heading">{displayServiceDescription}</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t('Back')}
            </span>
          </button>       
          <h2 className="page-heading">{displayServiceDescription}</h2>
        </div>
      }

      

      <div className="col-6 support-services-image-wrapper">
        {/* Displaying the image dynamically based on ServiceDescription */}
        <img
          src={getServiceImage(ServiceDescription)}
          alt={ServiceDescription}
          className="img-fluid support-services-image"
        />
      </div>
      <div className="col-xl-6 col-sm-12 mb-md-5 mb-ms-3 mb-5">
  {serviceDetails.length > 0 ? (
    <div>
      {serviceDetails.map((service) => {
        const serviceData = getDescription(service.ServiceDetailDescription);
        return (
          <div
            key={service.ServiceDetailId}
            className="schedule-block support-services"
            onClick={() => handleCardClick(service)}
          >
            {/* Adding icon dynamically */}
            <span className={`schedule-block-left-icons ${serviceData.iconClass}`}>
              <i className={`bi ${serviceData.iconClass}`} style={{ fontSize: "1.5rem" }}></i>
            </span>
            <div className="service-content">
              <h4>
                {service.ServiceDetailDescription}
              </h4>
              <p className="service-description">{
  (service.ServiceDetailDescription === "WIN Virtual Network") ? (
    displayServiceDescription === "Caregiver Support" ?
      "Find virtual care and support powered by Family First" :
    displayServiceDescription === "Gender-Affirming Support" ?
      <>Find virtual care and support with Plume. Use coupon code WIN25 to access your benefit</> :
      "Find virtual care and support."
  ) : serviceData.description
}</p>
            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <p>{error || t("loadingservice")}</p>
  )}
</div>


      {/* {isChatVisible && <ChatBotWindow />} */}
    </>
  );
};

// Function to get corresponding description for the title


export default SupportServices;
